import React, { useState, useRef, useEffect } from 'react';
import NotificationPanel from './NotificationPanel';
import NotificationPreferences from './NotificationPreferences';
import useNotifications from '../../../hooks/useNotifications';
import './NotificationBell.scss';

const NotificationBell = ({ onNavigate }) => {
  const { notifications, unreadCount, loading, markAsRead, markAllAsRead, ensureLoaded } =
    useNotifications();
  const [showPanel, setShowPanel] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const bellRef = useRef(null);

  // Close panel on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setShowPanel(false);
      }
    };
    if (showPanel) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showPanel]);

  const handleNotificationClick = (notification) => {
    markAsRead(notification.id);
    setShowPanel(false);

    // Navigate to resource
    if (notification.resource_type === 'ticket' && notification.resource_id) {
      onNavigate?.('ticket', null, notification.resource_id);
    } else if (notification.resource_type === 'work_item' && notification.resource_id) {
      onNavigate?.('work_item', null, notification.resource_id);
    }
  };

  const handleOpenPreferences = () => {
    setShowPanel(false);
    setShowPreferences(true);
  };

  return (
    <div className="notification-bell" ref={bellRef} data-tour="notification-bell">
      <button
        className="bell-btn"
        onClick={() => { const willOpen = !showPanel; setShowPanel(willOpen); if (willOpen) ensureLoaded(); }}
        title="通知"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path
            d="M13.73 13a2 2 0 01-1.73 1H6a2 2 0 01-1.73-1M14 7A5 5 0 004 7c0 5-2 7-2 7h14s-2-2-2-7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M10.3 16a1.4 1.4 0 01-2.6 0" />
        </svg>
        {unreadCount > 0 && <span className="bell-dot" />}
      </button>

      {showPanel && (
        <NotificationPanel
          notifications={notifications}
          loading={loading}
          unreadCount={unreadCount}
          onMarkAsRead={markAsRead}
          onMarkAllAsRead={markAllAsRead}
          onNotificationClick={handleNotificationClick}
          onClose={() => setShowPanel(false)}
          onOpenPreferences={handleOpenPreferences}
        />
      )}

      <NotificationPreferences
        isOpen={showPreferences}
        onClose={() => setShowPreferences(false)}
      />
    </div>
  );
};

export default NotificationBell;
